import React, { useState } from 'react';

import { Modal } from '@atlaskit/onboarding';

import { FEATURE_FLAG } from '@qality/common-config';
import {
  StorageOfUniqueServices,
  UserPropertyService,
  UserService,
} from '@qality/common-service';

export const TRACEABILITY_PAGE_INFO_PROPERTY =
  'TRACEABILITY_PAGE_INFO_PROPERTY';

export const TraceabilityReportPageInfo = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState({});

  React.useEffect(() => {
    const init = async () => {
      try {
        const userTemp = await UserService.getCurrentUser();
        setUser(userTemp);
        const result = await UserPropertyService.getProperty(
          TRACEABILITY_PAGE_INFO_PROPERTY,
          userTemp
        );
        setIsOpen(!result.value?.seenInformation);
      } catch (_e) {
        // in case we could not fetch info then just show the modal
        setIsOpen(true);
      }
    };

    init();
  }, []);

  const exploreTraceabilityReportPage = () => {
    setProperty();
    setIsOpen(false);
  };

  const openDocumentation = () => {
    setProperty();
    const url =
      'https://soldevelo.atlassian.net/wiki/spaces/QS/pages/3836706834/Traceability+Report';

    window.open(url, '_blank');
  };

  const setProperty = () => {
    try {
      UserPropertyService.setProperty(
        TRACEABILITY_PAGE_INFO_PROPERTY,
        { seenInformation: true },
        user
      );
    } catch (_e) {
      // do nothing, we do not want to show warning here
    }
  };

  return (
    <>
      {FEATURE_FLAG.isPremium && isOpen && (
        <Modal
          actions={[
            {
              onClick: exploreTraceabilityReportPage,
              text: 'Explore Traceability Report',
            },
            { onClick: openDocumentation, text: 'Learn more' },
          ]}
          heading='Tracking in its simplest form'
          image={StorageOfUniqueServices.get(
            'URLService'
          ).getTraceabilityReportPageCoverPath()}
          key='traceabilityReportPageInfo'
        >
          <p>
            QAlity Plus helps you track the relationship between your test
            cases, executions, and reported bugs. Meeting quality standards has
            never been easier!
          </p>
          <p>If you need more guidance, learn more from our documentation.</p>
        </Modal>
      )}
    </>
  );
};
